import Client from '../AxiosClient';
const resource = '/private/emulation';

export default {
    async getEmulation(year,employee_id,department_id,emulation_group_id) {
        try {
            year = year !== undefined ? year : null;
            employee_id = employee_id !== undefined ? employee_id : "";
            department_id = department_id !== undefined ? department_id : "";
            emulation_group_id = emulation_group_id !== undefined ? emulation_group_id : "";
            const response = await Client.get(`${resource}?year=${year}&employee_id=${employee_id}&department_id=${department_id}&emulation_group_id=${emulation_group_id}&status=1`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async getEmulationDepartment(year,month,full_name,department_id,emulation_group_id,approver_status) {
        try {
            year = year !== undefined ? year : null;
            month = month !== undefined ? month : -1;
            full_name = full_name !== undefined ? full_name : "";
            department_id = department_id !== undefined ? department_id : -1;
            emulation_group_id = emulation_group_id !== undefined ? emulation_group_id : "";
            approver_status = approver_status !== undefined ? approver_status : -1;
            const response = await Client.get(`${resource}?year=${year}&month=${month}&full_name=${full_name}&&department_id=${department_id}&emulation_group_id=${emulation_group_id}&approver_status=${approver_status}&status=1`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async getEmulationOffice(year,month,full_name,department_id,emulation_group_id) {

        try {
            year = year !== undefined ? year : null;
            month = month !== undefined ? month : -1;
            full_name = full_name !== undefined ? full_name : "";
            department_id = department_id !== undefined ? department_id : -1;
            emulation_group_id = emulation_group_id !== undefined ? emulation_group_id : "";
            const response = await Client.get(`${resource}/office?year=${year}&month=${month}&full_name=${full_name}&&department_id=${department_id}&emulation_group_id=${emulation_group_id}`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async insertEmulation(data) {
        try {
            const response = await Client.post(`${resource}/`,data);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async updateEmulation(data) {
        try {
            const response = await Client.put(`${resource}/`,data);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async updateApproverStatus(data) {
        try {
            const response = await Client.put(`${resource}/approver_status`,data);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async deleteEmulation(id) {
        try {
            const response = await Client.delete(`${resource}/${id}`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async reportByDepartment(department_id,year,emulation_group_id) {
        try {
            const response = await Client.get(`${resource}/reportbydepartment?year=${year}&emulation_group_id=${emulation_group_id}&department_id=${department_id}`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async downloadReportByDepartment(department_id,year,emulation_group_id) {
        try {
            const params={
                department_id:department_id,
                year:year,
                emulation_group_id:emulation_group_id
            }

            const response = await Client.get(`${resource}/exportbydepartment`, {
                headers: {
                "Access-Control-Expose-Headers": "Content-Disposition"
                },
                responseType: 'blob',
                params: params
            });
            
            // console.log(params)
            // const response = await Client.get(`${resource}report`, {
            //     headers: {
            //     "Access-Control-Expose-Headers": "Content-Disposition"
            //     },
            //     responseType: 'blob',
            //     params: params
            // });
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },

    async downloadOfficeSummaryReport(department_id,year, month, emulation_group_id) {
        try {
            const params={
                department_id:department_id,
                year:year,
                emulation_group_id:emulation_group_id,
                month: month
            }

            const response = await Client.get(`${resource}/exportofficesummary`, {
                headers: {
                "Access-Control-Expose-Headers": "Content-Disposition"
                },
                responseType: 'blob',
                params: params
            });
            
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    
    async getDetail(id) {
        try {
            const response = await Client.get(`${resource}/detail/${id}`);
            //console.log(response);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },

    async getTarget(id,status) {
        console.log("getTarget");
        try {
            let params = "?";
            params += id != undefined ? `id=${id}` : ``;
            params += status != undefined ? `&status=${status}` : ``;
            //const response = await Client.get(`${resource}/target?${params}`);
            const response = await Client.get(`${resource}/target${params}`);
            //console.log(response);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async insertTarget(data) {
        try {
            const response = await Client.post(`${resource}/target`,data);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async updateTarget(data) {
        try {
            const response = await Client.put(`${resource}/target`,data);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async deleteTarget(id) {
        try {
            const response = await Client.delete(`${resource}/target?id=${id}`)
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },

    async getGroup(id,group_name,status) {
        try {
            id = id !== undefined ? id : 0;
            status = status !== undefined ? status : 1;
            group_name = group_name !== undefined ? group_name : "";
            const response = await Client.get(`${resource}/group?id=${id}&group_name=${group_name}&status=${status}`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async getGroupByEmployee(employee_id) {
        try {
            const response = await Client.get(`${resource}/group/byemployee/${employee_id}`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async insertGroup(data) {
        try {
            const response = await Client.post(`${resource}/group`,data);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async updateGroup(data) {
        try {
            const response = await Client.put(`${resource}/group`,data);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async deleteGroup(id) {
        try {
            const response = await Client.delete(`${resource}/group/${id}`)
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },


    async getGroupTarget(id) {
        try {
            const response = await Client.get(`${resource}/grouptarget?group_id=${id}`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async getGroupTargetByGroupId(id) {
        try {
            const response = await Client.get(`${resource}/grouptarget/${id}`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
     async insertGroupTarget(data) {
        try {
            const response = await Client.post(`${resource}/grouptarget`,data);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },


    async getGroupUser(id) {
        try {
            const response = await Client.get(`${resource}/groupuser/${id}`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async insertGroupUser(data) {
        try {
            const response = await Client.post(`${resource}/groupuser`,data);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },

}